import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../store";
import HomeServices from "../../pages/home/homeService/HomeService";

interface FavoriteState {
  favorites: any[];
  favoritesCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: FavoriteState = {
  favorites: [],
  favoritesCount: 0,
  loading: false,
  error: null,
};

export const fetchFavorites = createAsyncThunk(
  "favorites/fetchFavorites",
  async () => {
    const response = await HomeServices.getFavorites();
    const data = response?.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(response)) return response;
    return [];
  }
);

const favoriteSlice = createSlice({
  name: "favorites",
  initialState,
  reducers: {
    removeFavorite: (state, action) => {
      const productId = action.payload;
      state.favorites = state.favorites.filter((item) => item.id !== productId);
      state.favoritesCount = state.favorites.length;
    },
    clearFavorites: (state) => {
      state.favorites = [];
      state.favoritesCount = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFavorites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFavorites.fulfilled, (state, action) => {
        state.loading = false;
        state.favorites = Array.isArray(action.payload) ? action.payload : [];
        state.favoritesCount = state.favorites.length;
      })
      .addCase(fetchFavorites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "error favorite";
      });
  },
});

export const { removeFavorite, clearFavorites } = favoriteSlice.actions;
export const selectFavorites = (state: RootState) => state.favorites.favorites;
export const selectFavoritesCount = (state: RootState) =>
  state.favorites.favoritesCount;

export default favoriteSlice.reducer;
